import axios from 'axios';
import { BookingSettingsResponseDto, CalendarCapabilities, CalendarConnectionResponse, CreateBookingSettingsDto } from '../types/booking';
import { SERVICES_API_BASE_URL } from './apiConfig';

const API_BASE = `${SERVICES_API_BASE_URL}/api/BookingSettings`;

const api = axios.create();

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

export const bookingSettingsApi = {
  getSettings: () => api.get<BookingSettingsResponseDto>(API_BASE),
  getCalendarConnection: () => api.get<CalendarConnectionResponse>(`${API_BASE}/calendar-connection`),
  // Backend exposes a single create-or-update endpoint (no separate PUT, no calendar/crm sync sub-routes).
  saveSettings: (data: CreateBookingSettingsDto) => api.post<BookingSettingsResponseDto>(API_BASE, data),
  getCalendarCapabilities: async () => {
    const response =
      await api.get<CalendarCapabilities>(
        `${API_BASE}/calendar-capabilities`
      );

    return response.data;
  },
};

